import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Typography } from '@mui/material'

import NewDashboardFilters from '@/components/UI/Dashboard/DashboardFilters/NewDashboardFilters'
import ConvoLogs from './ConvoLogs'
import DashboardNavigation from '../Dashboard/pages/DashboardNavigation'

const BotResponses = () => {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const [filters, setfilters] = useState({
    filter_from_date: null,
    filter_to_date: null,
    filter_channel: null,
    filter_connection_ids: null,
    filter_botmode: null,
  })
  const queryParams = new URLSearchParams(history.location.search)
  const [activeTab, setActiveTab] = useState<string>(
    queryParams.get('activeTab') || 'all',
  )

  const hasFilterUpdated = async (e: any) => {
    setfilters({
      ...filters,
      ...e,
    })
  }

  return (
    <section className="dashborad-wraper">
      <NewDashboardFilters hasFilterUpdated={hasFilterUpdated} />

      <DashboardNavigation />

      <div className="all-knowledge-search responses-by-ai tw-pt-4 tw-flex tw-flex-col tw-gap-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <Typography variant="body2" color="text.secondary">
              {t("Review learners’ questions and AI Assistant's answers.")}
            </Typography>
          </div>
        </div>

        <div className="chat-responses-tab mt-0">
          <Tabs
            defaultActiveKey={activeTab}
            onSelect={(e: string | null) => {
              if (!e) return
              setActiveTab(e)
              const params = new URLSearchParams(history.location.search)
              params.set('activeTab', e)
              history.replace({
                pathname: history.location.pathname,
                search: params.toString(),
              })

              if (e === 'all') {
                setfilters({
                  ...filters,
                  filter_botmode: null,
                })
              } else {
                setfilters({
                  ...filters,
                  filter_botmode: e,
                })
              }
            }}
            activeKey={activeTab}
          >
            <Tab eventKey="all" title={t('All Responses')}></Tab>
            <Tab
              eventKey={'document_searching'}
              title={t('Contextualised Chat Responses')}
            ></Tab>
            <Tab
              eventKey="improvising"
              title={t('Responses from External Sources')}
            ></Tab>
            <Tab eventKey="unanswered" title={t('Unanswered Questions')}></Tab>
          </Tabs>
        </div>

        <ConvoLogs filters={filters} />
      </div>
    </section>
  )
}

export default BotResponses
